import { AfterViewInit, Component, ElementRef, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-trustpilot-widget',
  templateUrl: './trustpilot-widget.component.html',
})
export class TrustpilotWidgetComponent implements AfterViewInit {
  @ViewChild('trustbox', { static: true }) trustboxRef!: ElementRef<HTMLElement>;
  @Input() token: string = 'aa894993-3b30-43ca-a45b-d0f9ce607f94';
  @Input() templateId: string = '5406e65db0d04a09e042d5fc';
  @Input() businessUnitId: string = '5f835b854728f0000122ae06';
  @Input() styleHeight: string = '28px';
  @Input() styleWidth: string = '100%';
  @Input() locale: string = 'en-US';
  @Input() theme?: 'light' | 'dark';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const win = window as any;
    const tryRender = () => {
      if (win.Trustpilot && typeof win.Trustpilot.loadFromElement === 'function') {
        win.Trustpilot.loadFromElement(this.trustboxRef.nativeElement, true);
      } else {
        setTimeout(tryRender, 200);
      }
    };
    tryRender();
  }
}
